import axios from 'axios';
import { useEffect } from 'react';

import { BFF_BASE_URL } from '../auth/authApi';
import { sceneSignals } from './sceneSignals';
import { MapPoint, MAX_MAP_POINTS } from './vectorMap';

interface AdminVectorPoint extends MapPoint {
    timestamp?: string | null;
}

/** Oldest first, so the scene keeps the newest points when there are too many. */
const byAge = (a: AdminVectorPoint, b: AdminVectorPoint) =>
    (a.timestamp ?? '').localeCompare(b.timestamp ?? '');

/** Feeds the background scene the memory map of every user, loaded once on startup. */
export const useVectorMapFeed = () => {
    useEffect(() => {
        let cancelled = false;

        const refresh = async () => {
            try {
                const response = await axios.get<{ points: AdminVectorPoint[] }>(
                    `${BFF_BASE_URL}/admin/vectors/3d`,
                    { params: { limit: MAX_MAP_POINTS } }
                );
                if (!cancelled) {
                    const points = [...response.data.points].sort(byAge);
                    sceneSignals.setVectorMap(
                        points.map(({ id, x, y, z }) => ({ id, x, y, z }))
                    );
                }
            } catch (error) {
                // The scene keeps its placeholder nodes.
                console.warn('Memory map fetch failed:', error);
            }
        };

        refresh();
        return () => {
            cancelled = true;
        };
    }, []);
};
